import {useEffect, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, Grid, Stack} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {useTranslation} from "react-i18next";
import {useForm, FormProvider} from "react-hook-form";
import {useRecoilState} from "recoil";
import {associationInfoState} from "../../../search-dms/state";
import FormTextField from "../../../common/form-fields-wrappers/FormTextField";
// import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {useNavigate} from "react-router-dom";

const AssociationInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const [associationInfo, setAssociationInfo] = useRecoilState(associationInfoState);
    // const {dispatchGlobalData} = useContext(GlobalContext);
    const associationInfoForm = useForm({
        defaultValues: {
            id: associationInfo.id,
            applicationIdentifyingCode: associationInfo?.applicationIdentifyingCode ?? "",
            applicationLink: associationInfo?.applicationLink ?? "",
        }
    });
    const onSubmit = () => {
        // const reqParameters = {
        //     id: associationInfo.id,
        //     applicationId: associationInfo.applicationId,
        //     applicationIdentifyingCode: data.applicationIdentifyingCode,
        //     applicationLink: data.applicationLink,
        // }
        setOpen(false);
        setIsDisabled(true);
        setAssociationInfo(associationInfo);
        // updateassociationInfo(reqParameters)
        //     .then( (res:any) => {
        //         console.log(res);
        //         setAssociationInfo(res.associationInfo);
        //     })
        //     .catch((err: AxiosError) => {
        //         dispatchGlobalData(SET_SNACKBAR.ERROR);
        //     });

    }
    const [isDisabled, setIsDisabled] = useState(true);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open, setOpen] = useState(false);
    // const handleDisableForm = (value: boolean) => {
    //     setIsDisabled(value);
    // }
    let navigate = useNavigate();
    // ROUTE CHANGE VERSIONE 1
    // const routeChange = (idApplication: any) => {
    //     let path = `/mobility-store/application-detail/`;
    //     let reqParameters = {
    //         applicationId: idApplication
    //     }
    //     getApplicationById(reqParameters)
    //         .then( (res:any) => {
    //             console.log(res);
    //             navigate(path, {state: res.application});
    //         })
    //         .catch((err: AxiosError) => {
    //             dispatchGlobalData(SET_SNACKBAR.ERROR);
    //         });
    // }

    // ROUTE CHANGE VERSIONE 2
    const routeChange = (idApplication: any) => {
        let path = `/mobility-store/application-detail/${idApplication}`;
        navigate(path, {state: {idApplication}});
    }

    useEffect(() => {
        associationInfoForm.setFocus("applicationIdentifyingCode");
        associationInfoForm.setValue("applicationIdentifyingCode", associationInfo?.applicationIdentifyingCode);
        associationInfoForm.setFocus("id");
        associationInfoForm.setValue("id", associationInfo?.id);
    }, [associationInfo])


    return (
        <>
            <FormProvider {...associationInfoForm}>
                <Grid container direction="row" alignItems="center">
                    {/*<Grid item xs={12}>*/}
                    {/*    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">*/}
                    {/*        { isDisabled ? <Tooltip title="Edit">*/}
                    {/*            <BorderColorIcon*/}
                    {/*                style={{*/}
                    {/*                    color: "#C8017D"*/}
                    {/*                }}*/}
                    {/*                onClick={() => {handleDisableForm(false)}}*/}
                    {/*            />*/}
                    {/*        </Tooltip> : null }*/}
                    {/*    </Stack>*/}
                    {/*</Grid>*/}
                    <Grid container direction="row" alignItems="center" xs={12} columnSpacing={2}>

                        <Grid item xs={3}>
                            <FormTextField
                                disabled
                                control={associationInfoForm.control}
                                name="applicationIdentifyingCode"
                                label={t("dmsDetail.associationInfo.form.label.applicationIdentificationCode")}
                            />
                        </Grid>

                        {associationInfo.applicationLink !== null &&
                            <Grid item justifyContent="center" xs={3}>
                                <Button onClick={() => routeChange(associationInfo.applicationId)}>
                                    {t("dmsDetail.associationInfo.button.appDetail")}
                                </Button>
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                {!isDisabled &&
                                    <Button variant="contained" onClick={handleOpen}>
                                        {t("dmsDetail.associationInfo.button.edit")}
                                    </Button>}
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("dmsDetail.associationInfo.dialog.title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("dmsDetail.associationInfo.dialog.content")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}  variant={"outlined"} color={"accent"}>
                        {t("dmsDetail.associationInfo.dialog.action.cancel")}
                    </Button>
                    <Button onClick={associationInfoForm.handleSubmit(onSubmit)} autoFocus>
                        {t("dmsDetail.associationInfo.dialog.action.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AssociationInfo;
